<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> NDR Scan Rack</strong>
            <!--    <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="rackadd()"  type="button">Add New Rack</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
            </div> -->
          </div>
          <!--  <div id="addrack"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row> 
                  <b-col sm="4">
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Rack No</label>
                      <div class="col-md-9">
                        <b-form-input class="form-control" type="text" name="rackno" v-model="rackno" v-validate="'required|alpha_num|min:3|max:30'"placeholder="Enter Rack No" :class="{'input': true, 'text-danger': errors.has('form-1.rackno') }"  >
                       </b-form-input>
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('rackno')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.rackno')" class="help text-danger">{{ errors.first('form-1.rackno') }}</span>
                      </b-input-group>
                      </div>
                    </div>                   
                  </b-col>
                
                  <b-col sm="3">
                    <b-button variant="primary" size="md" type="submit">Save</b-button>
                  </b-col>
                </b-row>  
              </b-form>
          </div>
          -->
          <b-row>
            <b-col md="12">

              <div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item" v-for="item in items">
                    <a @click="activeTab = item.id; activeTabName = item.rackno; displayracklist(activeTab)"
                      class="nav-link" :class="{ 'active': isActiveTab(item.id) }">{{ item.rackno }}</a>
                  </li>


                  <!--  <li class="nav-item">
                <a @click="activeTab = 1; displaydata(activeTab)"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Rack 2</a>
              </li> -->

                  <!--   <li class="nav-item">
                <a @click="activeTab = 2;  displaydata(activeTab)"  class="nav-link " :class="{'active' : isActiveTab(2)}">Rack 3</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3;  displaydata(activeTab)"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Rack 4</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 4;  displaydata(activeTab)"  class="nav-link " :class="{'active' : isActiveTab(4)}">Rack 5</a>
              </li>  -->

                </ul>
              </div>




            </b-col>
            <b-col md="12">

            </b-col>
            <div id="overlay">
              <div class="loader"></div>
            </div>
            
            <b-col md="4" class="my-1 mt-3">
              <b-col sm="12">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-col>

            <b-col sm="12" class="text-right">
              <p> <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              <b-button v-if="this.totalRows > 0" variant="primary" size="md" @click="downloadCSV">Download </b-button>
            </b-col>

            <b-row>
              <b-col sm="12">
                <b-button style="margin-left: 25px; " id="printbutton" variant="primary" size="md" value="print a div!"
                  @click="barcodedata('printableArea')">Print Rack</b-button>

              </b-col>
            </b-row>
            <div id="printableArea" style="display:none;">
              <!--  <span><b>{{this.activeTab}}</b></span> -->
              <span><b>{{ this.activeTabName }}</b></span>
              <barcode v-bind:value="this.activeTab">

              </barcode>

            </div>



            <b-col md="12">
              <b-col sm="12">
                <div class="tab-panel">
                  <b-table show-empty stacked="md" :items="itemslist" :busy="isBusy" :current-page="currentPage"
                    :fields="fields" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered" @filtered="onFiltered">

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>


                  </b-table>
                </div>
              </b-col>
              <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                  class="my-0"></b-pagination>
              </b-col>




              <!--  <documents v-if="isActiveTab(3)"></documents> -->
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
  </div>

</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import VueBarcode from 'vue-barcode';

export default {
  data: function () {
    return {

      isBusy: false,


      fields: [
        { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc' },
        { key: 'deliverystatus', label: 'Status', sortable: true, sortDirection: 'desc' },
        { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
        { key: 'vendor_name', label: 'Vendor_Name', sortable: true, sortDirection: 'desc' },
        { key: 'pickuplocationaddress', label: 'pick up Address', sortable: true, sortDirection: 'desc' },
        { key: 'shipaddress1', label: 'Shipping Address', sortable: true, sortDirection: 'desc' },


        { key: 'deliverystatusname', label: 'Delivery Status Reason', sortable: true, sortDirection: 'desc' },



      ],
      add: true,
      rackno: '',
      items: [],
      itemslist: [],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      filter: null,
      sortDesc: false,
      sortDirection: 'desc',
      activeTab: '',
      activeTabName: '',

      name: 'exceptionReport'
    };
  },
  components: {
    'barcode': VueBarcode
  },

  created: function () {


    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.currenthubidselct = userInfo.pickuplocationmasterid.toString();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  methods: {
    isActiveTab(id) {
      return this.activeTab === id
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.addRackInfo();
        }
      });
    },
    clear1: function () { },
    rackadd: function () {
      this.errors.clear("form-1");

      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addrack = document.getElementById("addrack");
      addrack.style.display = "block";

    },
    refresh: function () {

      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addrack = document.getElementById("addrack");
      addrack.style.display = "none";
      this.clear();
    },

    chkrackVal: function () {
      var length = this.items.length;
      var needle = this.rackno.toLowerCase();
      for (var i = 0; i < length; i++) {
        // console.log(this.items[i].rackno +' '+needle);
        if (this.items[i].rackno.toLowerCase() == needle) {
          return true;
        }
      }
      return false;
    },
    downloadCSV: function () {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById("overlay").style.display = "block";

      // alert(" i m i  Download");
      var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));

      var csvObj = {

        rack_id: this.activeTab,
        sysusermasterid: `${userInfo.sysusermasterid}`,
        hub_id: `${userInfo.pickuplocationmasterid}`,
        searchtext: this.filter ? this.filter : '',
      };

      // console.log(csvObj);


      // var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
      // console.log(queryString);

      //var r = Math.random().toString(36).substring(3);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getndrrackshipmentlistcsv_advanced`, csvObj)
        .then(result => {
          // console.log(result.url);
          document.getElementById("overlay").style.display = "none";
          if (result.body == "success") {
            // alert("Please Check Ur Mail For Downlod Link")
            this.$fire({
              text:"Please Check Ur Mail For Downlod Link",
              type: "success",
              timer: 30000
            }); 
          }
          else {
            // alert("Can not Download");
            this.$fire({
              text:"Can not Download",
              type: "error",
              timer: 30000
            }); 
          }
          //window.location.href =result.url;
        });

    },

    barcodedata(printableArea) {
      var printContents = document.getElementById("printableArea").innerHTML;

      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = printContents;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      //  docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      // docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      // docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:40px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      // docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 100px;text-align: center;}');

      // docprint.document.write('.addpad{ padding: 10px; }');


      // docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

      // docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


      // docprint.document.write('.stickertable td{ padding-bottom:10px;line-height:1.5  }');

      docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');





      docprint.document.write('</head><body onLoad="self.print()"><center>');



      docprint.document.write(content_vlue);
      docprint.document.write('</center></body></html>');
      docprint.document.close();



    },
    addRackInfo: function () {
      var chkrackVal = this.chkrackVal();

      if (chkrackVal == false) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.currenthubidselct = userInfo.pickuplocationmasterid.toString();
        this.$validator.validateAll().then(result => {
          if (result) {
            const rackinfosave = {
              hubid: `${this.currenthubidselct}`,
              status: 0,
              rack_type: 1,
              rackno: `${this.rackno.toLowerCase().trim()}`,
              hubid: `${userInfo.pickuplocationmasterid}`,
            }
            // console.log(rackinfosave);
            this.$http
              .post(
                `${CONSTANTS.API_URL
                }/DeliveryAgentMaster/RackMasterAdd`,
                rackinfosave
              )
              .then(result => {
                if (result.body.returnmsg === "Successful") {
                  Utils.notify("Added successfully", "success");
                  //   this.$fire({
                  //   text:"Added Successfully",
                  //   type: "success",
                  //   timer: 30000
                  // });
                  var addrack = document.getElementById("addrack");
                  addrack.style.display = "none";
                  this.clear();
                  this.displaydata();
                  // this.$router.push('/rack');
                } else {
                  if (result.body.returnmsg === "unsuccessful") {
                    Utils.notify(result.body[0].returnvalue, "error");
                    //     this.$fire({
                    //   text:result.body[0].returnvalue,
                    //   type: "error",
                    //   timer: 30000
                    // });
                  } else if (result.body[0].returnvalue === "0") {
                    Utils.notify(result.body[0].returnmsg, "error");
                    //     this.$fire({
                    //   text:result.body[0].returnmsg,
                    //   type: "error",
                    //   timer: 30000
                    // });
                  } else {
                    Utils.notify(result.body[0].returnmsg, "error");
                    //       this.$fire({
                    //   text:result.body[0].returnmsg,
                    //   type: "error",
                    //   timer: 30000
                    // });
                  }
                }
                this.$router.push('/rack');
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
            // this.$fire({
            //       text:"Errors Correct them ",
            //       type: "error",
            //       timer: 30000
            //     });
          }
        });
      } else {
        Utils.notify("This number is already exist", "error");
        // this.$fire({
        //           text:"This number is already exist",
        //           type: "warning",
        //           timer: 30000
        //         });
      }
    },

    clear: function () {
      this.rackno = '';
      this.errors.clear('form-1')
    },
    displaydata: function () {



      this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // this.currenthubidselct=userInfo.pickuplocationmasterid.toString();

      const rackinfo = {
        // hubid: `${this.currenthubidselct}`,
        hub_id: `${userInfo.pickuplocationmasterid}`,
        rack_type: 1,
        // hub_id:`${userInfo.pickuplocationmasterid}`,

      }
      console.log("gggg", rackinfo);
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getracklistbyhub`, rackinfo)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.items = result.body.returnvalue;
            this.activeTab = result.body.returnvalue[0].id;
            this.activeTabName = result.body.returnvalue[0].rackno;
            this.displayracklist(this.activeTab);
            //this.totalRows = result.body.returnvalue.length;
            //this.isBusy = !this.isBusy;

          } else {
            alert("No Racks Available")
            // this.$fire({
            //      text:"No Racks Available",
            //      type: "warning",
            //      timer: 30000
            //    });
            //this.items=[];
            //this.totalRows =0;
            //this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },

    onFiltered(filteredItems) {
      // console.log("filteredItems--->",filteredItems)
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    displayracklist: function (activeTab) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)


      //var a=this.activeTab;
      //alert(a);
      this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.currenthubidselct = userInfo.pickuplocationmasterid.toString();

      const racklistinfo = {

        rack_id: this.activeTab,
        // hub_id:`${userInfo.pickuplocationmasterid}`,  
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getndrrackshipmentlist`, racklistinfo)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.itemslist = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length;
            this.isBusy = !this.isBusy;

          } else {
            this.itemslist = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },


  }
};
</script>
<style type="text/css">
#overlay {
  position: fixed;
  /* Sit on top of the page content */
  display: none;
  /* Hidden by default */
  width: 100%;
  /* Full width (cover the whole page) */
  height: 100%;
  /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with opacity */
  z-index: 2;
  /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer;
  /* Add a pointer on hover */
}

.loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>